var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useGroupStorage } from '../../../../../../AppClients';
import { accountEntityName, addAccountsToGroupBulkActionType, } from '../../../../../../backend/features/accounts/shared';
import { groupEntityName, removeAccountsFromGroupBulkActionType } from '../../../../../../backend/features/groups/shared';
import { getAccountsManageFilter, requireAnyOrgPermission, requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { AccountSlideout, showAccountsDialog, showRemoveAccountDialog, useAccountsTable, } from '../../../../../../ui/features/accounts';
import { AccountsIManageSwitch, showAccountsIManageFilterName } from '../../../../../../ui/features/accounts/components/AccountsIManageSwitch';
import { handleAddToOrganization } from '../../../../../../ui/features/organizations/components/OrganizationsPanel/utils/AccountTableActionHandlers/handleAddToOrganization';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { ContactManagementConfigContext } from '../../../../../../ui/providers';
import { getFilterForBulkAction } from '../../../../../../utils';
import { DataTable, useDataTableUsingState, useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { beginExport } from '@juvare/platform-sdk-react/ui/components/EntityTable/entityExport';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { showEntityImportDialog } from '@juvare/platform-sdk-react/ui/features/entity-import';
import { useExportClient } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DomainAddOutlinedIcon from '@mui/icons-material/DomainAddOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { showGroupDetailsDialog } from './GroupDetailsDialog';
import { showGroupsDialog } from './GroupsDialog';
export const GroupMembers = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { group } = props;
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const hasExportPermission = requireAnySystemPermission(userState, 'export-accounts') && settings.accountsExportEnabled;
    const isFilterBasedGroup = group.data.filterBased;
    const { t } = useContactManagementTranslation();
    const exportClient = useExportClient();
    const groupStorageClient = useGroupStorage();
    const [searchParams] = useSearchParams();
    const location = {
        name: 'group-members',
        groupId: group.id,
        filterBased: group.data.filterBased,
        groupFilter: group.data.criteria.filters,
    };
    const useDataTableFunction = props.useDataTableState ? useDataTableUsingState : useDataTableUsingUrl;
    const handleSaveFilter = () => {
        var _a, _b, _c;
        groupStorageClient
            .post({
            action: 'partial-update',
            id: props.group.id,
            data: { criteria: { filters: (_c = (_b = (_a = dataTableProps.customBackendResponseData) === null || _a === void 0 ? void 0 : _a.storageClientRequest) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : [] } },
        })
            .then(() => {
            showInfoSnackbar({
                message: t('panels.groups.filterSaved'),
                autoHideDuration: 2000,
            });
            props.onReloadGroup();
        })
            .catch(handleErrorDialog);
    };
    const showAccountsIManage = searchParams.get(showAccountsIManageFilterName) === 'true';
    const { dataTableProps, appliedFilterData, clearActiveRow, reload } = useAccountsTable({
        location: location,
        rowSelectionEnabled: true,
        onRowClick: () => undefined,
        useDataTableFunction: useDataTableFunction,
        showAccountStatusFilter: 'quickFilter',
        showAccountSystemRoleFilter: 'onlyAllFiltersPanel',
        initialStorageClientFilter: getInitialStorageClientFilter(group === null || group === void 0 ? void 0 : group.data.criteria.filters, props.group.data.filterBased), // user can edit filter in a filter based group
        staticStorageClientFilter: props.group.data.filterBased ? undefined : group === null || group === void 0 ? void 0 : group.data.criteria.filters, // user cannot edit filter in a standard group
        onSaveFilter: group.data.filterBased ? handleSaveFilter : undefined,
        showAccountsIManage,
        defaultRowsPerPage: 100,
    });
    const appliedStorageFilters = (_c = (_b = (_a = dataTableProps.customBackendResponseData) === null || _a === void 0 ? void 0 : _a.storageClientRequest) === null || _b === void 0 ? void 0 : _b.filter) !== null && _c !== void 0 ? _c : [];
    if (showAccountsIManage) {
        appliedStorageFilters.push(...getAccountsManageFilter(userState));
    }
    const rowCount = dataTableProps.selectedRowIds && dataTableProps.selectedRowIds.length > 0
        ? dataTableProps.selectedRowIds.length
        : ((_d = dataTableProps.filteredRowCount) !== null && _d !== void 0 ? _d : 0);
    const handleAddAccounts = () => {
        showAccountsDialog({
            scope: 'view-accounts',
            title: t('panels.groups.addAccountsToGroupWithName', { groupName: group.data.name }),
            selectOperationName: t('common.add'),
            onSelect: (accountIds) => {
                if (accountIds.length > 0) {
                    launchBulkAction({
                        type: addAccountsToGroupBulkActionType,
                        title: t('panels.groups.addingAccountsToGroup'),
                        params: {
                            groupId: group.id,
                            filter: getFilterForBulkAction(accountIds, []),
                        },
                        onClose: () => {
                            reload();
                        },
                    });
                }
            },
        });
    };
    const handleRemoveAccounts = () => {
        var _a, _b;
        const selectedCount = dataTableProps.selectedRowIds && ((_a = dataTableProps.selectedRowIds) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? (_b = dataTableProps.selectedRowIds) === null || _b === void 0 ? void 0 : _b.length
            : dataTableProps.filteredRowCount;
        showRemoveAccountDialog({
            t,
            count: selectedCount !== null && selectedCount !== void 0 ? selectedCount : 0,
            onConfirm: () => {
                launchBulkAction({
                    type: removeAccountsFromGroupBulkActionType,
                    title: t('panels.groups.removingAccountsFromGroup'),
                    params: {
                        groupId: group.id,
                        filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                    },
                    onClose: () => {
                        var _a;
                        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                        reload();
                    },
                });
            },
        });
    };
    const handleExport = () => {
        var _a, _b;
        beginExport(exportClient, accountEntityName, (_a = settings.accountsExportFormat) !== null && _a !== void 0 ? _a : 'csv', dataTableProps.selectedRowIds, appliedStorageFilters, [
            {
                column: (_b = dataTableProps.sortColumnKey) !== null && _b !== void 0 ? _b : 'displayName',
                desc: dataTableProps.sortColumnDesc,
            },
        ]);
    };
    const handleExportAll = () => {
        var _a, _b;
        beginExport(exportClient, accountEntityName, (_a = settings.accountsExportFormat) !== null && _a !== void 0 ? _a : 'csv', undefined, group.data.criteria.filters, [
            {
                column: (_b = dataTableProps.sortColumnKey) !== null && _b !== void 0 ? _b : 'displayName',
                desc: dataTableProps.sortColumnDesc,
            },
        ]);
    };
    const addAccountToNewGroup = () => {
        showGroupDetailsDialog({
            initialData: {
                filterBased: false,
                visibility: 'private',
                criteria: { filters: [] },
            },
            fullWidth: true,
            maxWidth: 'sm',
            title: t('panels.accounts.newGroupAccount', { count: rowCount }),
            onSubmit: (data) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const { id } = yield groupStorageClient.post({ action: 'create', data: data });
                    launchBulkAction({
                        type: addAccountsToGroupBulkActionType,
                        title: t('panels.groups.addingAccountsToGroup'),
                        params: {
                            groupId: id,
                            filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                        },
                        onClose: () => {
                            var _a;
                            (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                            reload();
                        },
                    });
                }
                catch (error) {
                    handleErrorDialog(error);
                }
            }),
        });
    };
    const addAccountToExistingGroup = () => {
        showGroupsDialog({
            excludeFilterBasedGroups: true,
            selectedGroupId: group.id,
            onSelect: (selectedGroupId) => {
                launchBulkAction({
                    type: addAccountsToGroupBulkActionType,
                    title: t('panels.groups.addingAccountsToGroup'),
                    params: {
                        groupId: selectedGroupId,
                        filter: getFilterForBulkAction(dataTableProps === null || dataTableProps === void 0 ? void 0 : dataTableProps.selectedRowIds, appliedStorageFilters),
                    },
                    onClose: () => {
                        var _a;
                        (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                        reload();
                    },
                });
            },
        });
    };
    const globalActions = [];
    if (hasExportPermission) {
        globalActions.push({
            icon: React.createElement(FileUploadOutlinedIcon, null),
            label: t('panels.accounts.exportAll'),
            onClick: handleExportAll,
            'data-test': 'export-all-button',
        });
    }
    const localActions = [];
    if (accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.getDataTableProps) {
        const tableProps = accountsTableCustomization.getDataTableProps(dataTableProps, appliedFilterData, location);
        globalActions.push(...((_e = tableProps.globalActions) !== null && _e !== void 0 ? _e : []));
        localActions.push(...((_f = tableProps.localActions) !== null && _f !== void 0 ? _f : []));
    }
    if (!isFilterBasedGroup) {
        globalActions.push({
            label: t('panels.groups.addMembers'),
            'data-test': 'toolbar-add-members-button',
            icon: React.createElement(AddIcon, null),
            menuItems: [
                {
                    label: t('panels.groups.selectMembers'),
                    'data-test': 'toolbar-select-members-button',
                    onClick: handleAddAccounts,
                },
                {
                    label: t('panels.groups.importMembers'),
                    'data-test': 'toolbar-import-members-button',
                    onClick: () => {
                        showEntityImportDialog({
                            entity: groupEntityName,
                            options: {
                                dialogTitle: t('panels.groups.importMembers'),
                                csvTemplateName: t('import.groupsTemplateFileName'),
                                csvTemplate: 'MEMBERS\n"adam.hall@example.com"\n"philip.lyon@example.com;eli.sears@example.com"\n',
                                onAfterImport: reload,
                                metadata: {
                                    importFileType: 'groupMembers',
                                    groupId: group.id,
                                },
                            },
                        });
                    },
                },
            ],
        });
    }
    if (hasExportPermission) {
        localActions.push({
            icon: React.createElement(FileUploadOutlinedIcon, null),
            label: t('panels.accounts.export'),
            onClick: handleExport,
            'data-test': 'export-button',
        });
    }
    if (!isFilterBasedGroup) {
        localActions.push({
            icon: React.createElement(DeleteOutlineIcon, null),
            label: t('panels.groups.removeAccounts'),
            onClick: () => handleRemoveAccounts(),
            'data-test': 'toolbar-remove-accounts-button',
        });
    }
    localActions.push({
        icon: React.createElement(GroupAddOutlinedIcon, null),
        label: t('panels.accounts.addToGroup'),
        'data-test': 'toolbar-add-to-group-button',
        menuItems: [
            {
                label: t('panels.accounts.newGroup'),
                onClick: () => addAccountToNewGroup(),
                'data-test': 'new-group-button',
            },
            {
                label: t('panels.accounts.addToExistingGroup'),
                onClick: () => addAccountToExistingGroup(),
                'data-test': 'existing-group-button',
            },
        ],
    });
    if (settings.organizationsEnabled &&
        (requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members'))) {
        localActions.push({
            label: t('panels.accounts.addToOrganization'),
            icon: React.createElement(DomainAddOutlinedIcon, null),
            'data-test': 'toolbar-add-to-organization-button',
            onClick: () => handleAddToOrganization({
                t,
                accountIds: dataTableProps.selectedRowIds,
                totalFilteredAccounts: dataTableProps.filteredRowCount,
                appliedStorageFilters,
                onConfirm: () => {
                    var _a;
                    (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                    reload();
                },
            }),
        });
    }
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: { p: 2 } },
            React.createElement(DataTable, Object.assign({}, dataTableProps, { globalActions: globalActions, localActions: localActions, customHeaderElement: !requireAnySystemPermission(userState, 'manage-accounts') &&
                    requireAnyOrgPermission(userState, 'manage-members') ? (React.createElement(AccountsIManageSwitch, null)) : undefined }))),
        React.createElement(AccountSlideout, { accountId: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            }, accountListReload: reload, customMenuItems: props.customMemberSlideoutMenuItems, customDetailsComponent: props.customMemberDetailsComponent })));
};
function getInitialStorageClientFilter(groupFilter, filterBased) {
    const initialStorageClientFilter = [];
    let appendAccountStatusFilter = true;
    if (filterBased) {
        initialStorageClientFilter.push(...groupFilter);
        appendAccountStatusFilter = false; // Filter-based groups use only user-defined filters, so no need to append
    }
    if (appendAccountStatusFilter) {
        initialStorageClientFilter.push({ column: 'systemStatus', op: 'in', value: ['active'] });
    }
    return initialStorageClientFilter;
}
